module.exports = __webpack_public_path__ + "static/img/conponent.0b634bad.png";